module.exports = __webpack_public_path__ + "static/ofcar7-ad38e19d6dbe8fca3c27a01a76bf5223.jpg";